import axios from 'axios';

export const WEBRTC_ACTION_TYPES = {
  DISPLAY_INITIALLY: 1,
  CLICK_START_BUTTON: 2,
  SHOW_MOBILE_NOT_SUPPORT_ERROR: 3,
  SHOW_BROWSER_NOT_SUPPORT_ERROR: 4,
  OT_CHECK_SYSTEM_REQUIREMENTS: 5,
  OT_SUUPPORT_CHECK_SCREEN_SHARING_CAPABILITY: 6,
  OT_NOT_SUUPPORT_CHECK_SCREEN_SHARING_CAPABILITY: 7,
  OT_SESSION_CONNECTED: 8,
  OT_ERR_SESSION_CONNECTED: 9,
  OT_INIT_PUBLISH: 10,
  OT_ERR_INIT_PUBLISH: 11,
  OT_PUBLISH: 12,
  OT_ERR_PUBLISH: 13,
  OT_SUBSCRIBE: 14,
  OT_ERR_SUBSCRIBE: 15,
  CLICK_SUBMIT_BUTTON: 16,
};

const appendRelationId = (data, { answerConnectivityId, browserTestHistoryId }) => {
  if (answerConnectivityId) {
    data.append('answer_connectivity_id', answerConnectivityId);
  }
  if (browserTestHistoryId) {
    data.append('browser_test_history_id', browserTestHistoryId);
  }

  return data;
};

const recordWebrtcHistory = (idObj, actionType, optData) => {
  let data = new FormData();

  data = appendRelationId(data, idObj);
  data.append('action_type', actionType);
  data.append('data', optData);

  return axios.post('/api/users/webrtc_histories/', data);
};

export default recordWebrtcHistory;
